import alertIcon from "#resources/icons/Alert.svg";

// eslint-disable-next-line import/prefer-default-export
export const hazardIcons = {
  unknown: alertIcon,
};
